module.exports = __webpack_public_path__ + "img/mojito.1ddfe44e.jpg";